module.exports = __webpack_public_path__ + "img/iconWoDeTuiChuDengLu.c7d6bb14.svg";